import '../scss/main.scss';
import LocationMap from './location-map';

window.addEventListener('DOMContentLoaded', function(){
	let mapContainers = document.querySelectorAll('.mmap-wrapper');

	if (mapContainers.length < 1) {
		return;
	}

	mapContainers = [].slice.call(mapContainers);

	mapContainers.forEach( container => {

        const options = {
            zoomLvl: container.getAttribute('data-zoom-lvl') ? parseInt(container.getAttribute('data-zoom-lvl')) : '',
            typeLocation: container.getAttribute('data-type') ? container.getAttribute('data-type') : '',
            mapType: container.getAttribute('data-map-type') ? container.getAttribute('data-map-type') : '',
            location: container.getAttribute('data-location') ? container.getAttribute('data-location') : '',
            locationType: container.getAttribute('data-location-type') ? container.getAttribute('data-location-type') : '',
            buildsite: container.getAttribute('data-buildsite') ? container.getAttribute('data-buildsite') : '',
            centre: container.getAttribute('data-centre') ? container.getAttribute('data-buildsite') : '',
            activeCategories: container.getAttribute('data-active-categories') ? JSON.parse(container.getAttribute('data-active-categories')) : '',
            buildLocation: container.getAttribute('data-build-location') ? JSON.parse(container.getAttribute('data-build-location')) : '',
            centreLocation: container.getAttribute('data-centre-location') ? JSON.parse(container.getAttribute('data-centre-location')) : '',
            themeUrl: container.getAttribute('data-theme-url') ? container.getAttribute('data-theme-url') : '',
            gebiedId: container.getAttribute('data-gebied-id') ? container.getAttribute('data-gebied-id') : '',
        };

        if(options.locationType == 'coordinaten'){
            options.location = options.location.split(',').map(parseFloat);
        }

        const optionsFiltered = {};

        for (let key in options) {
            if (options[key]) {
                optionsFiltered[key] = options[key];
            }
        }

        new LocationMap(
            optionsFiltered,
            container,
            {
                services: endpoint_url_get_map_services,
                projecten: ajax_url_get_projecten_by_gebied
            },
            'http://maps.google.nl'
        );
	});
});